// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import request from './request'

/**
 * @description 获取临时key
 */
export function stockGetTempKeysApi() {
  return request.get(`upload/temp_key`)
}


/**
 *
 * 添加库存
 * */

export function warehousAddNum(data) {
  return request.post('recovery/warehous/add/num',data)
}

/**
 * @description 添加入库视频
 */
export function addVideoApi(data) {
  return request.post(`/recovery/order/express/video/update`,data)
}

/**
 * @description 回收入库
 */
export function uploadVideoApi(data,option) {
  return request.post(`upload/video`,data,option)
}

/**
 * @description 回收入库
 */
export function orderWarehousApi(data) {
  return request.post(`recovery/order/warehous`,data)
}


/**
 * @description 上传图片
 */
export function uploadFileApi(data,option) {
  return request.post(`upload/image/0/file`,data,option)
}

/**
 * @description 新增库存
 * */
export function addStock(data) {
  return request.post('recovery/stock/add/stock',data)
}

/**
 * @description 根据69码搜索sku
 */
export function recoverySearchSkuBy69NumApi(data) {
  return request.get(`recovery/order/search/searchSkuBy69Num`,data)
}


/**
 * @description 根据运单号搜索
 */
export function recoveryOrderDetailByExpNumApi(data) {
  return request.get(`recovery/order/search/detail`,data)
}

/**
 * @description 设置69码
 */
export function recoveryWarehousCodeUpdateApi(data) {
  return request.post('recovery/category/sku/code/update',data)
}

/**
 * @description 分配订单
 */
export function orderHandleApi(data){
  return request.post('recovery/order/allocation/handle',data)
}

/**
 * @description 分配余额
 */
export function amountHandleApi(data){
  return request.post('recovery/order/allocation/amount/handle',data)
}
/**
 * @description 搜索用户
 */
export function recoverSearchUserApi(data){
  return request.get('user/search/list',data)
}

/**
 * @description sku回收价格 -- 修改
 */
export function recoveryCategorySkuUpdateApi(data) {
  return request.post('recovery/category/sku/price/update',data)
}
/**
 * @description sku回收价格 -- 列表
 */
export function recoveryCategorySkuListApi() {
  return request.get('recovery/category/sku/price/list')
}
/**
 * @description 回收分类 -- 列表
 */
export function recoveryCategoryListApi() {
  return request.get('recovery/category/lst')
}
/**
 * @description 回收分类 -- 列表
 */
export function categoryList(data) {
  return request.get('recovery/category/list',data)
}
/**
 * 获取上一级分类
 */
export function recoveryCategoryMenuListApi(level) {
  return request.get(`recovery/category/menu/list/${level}`)
}

/**
 * 报存分类
 */
export function recoveryCategoryCreateApi(data) {
  return request.post(`recovery/category/create`,data)
}

/**
 * 分类详情
 */
export function recoveryCategoryDetailApi(id) {
  return request.get(`recovery/category/detail/${id}`,)
}

/**
 * 分类删除
 */
export function recoveryCategoryDeleteApi(id) {
  return request.delete(`recovery/category/delete/${id}`,)
}

/**
 * 分类开启
 */
export function recoveryCategoryStatusApi(id,status) {
  return request.post(`recovery/category/status/${id}`,{ status })
}

/**
 * 问题列表
 */
export function recoveryProblemListApi(data) {
  return request.get(`recovery/problem/lst`, data)
}
/**
 * 删除问题
 */
export function recoveryProblemDeleteApi(id) {
  return request.delete(`recovery/problem/delete/${id}`, )
}

/**
 * 新增问题
 */
export function recoveryProblemCreateApi() {
  return request.get('recovery/problem/create/form')
}
/**
 * 编辑表单
 */
export function recoveryProblemUpdateApi(id) {
  return request.get(`recovery/problem/update/form/${id}`)
}

/**
 * 订单列表
 */
export function recoveryOrderListApi(data) {
  return request.get(`recovery/order/list`, data)
}

/**
 * 订单头部统计
 */
export function recoveryOrderChartListApi(data) {
  return request.get(`recovery/order/chart/list`,data)
}


/**
 * 修改已入库相关数量
 * */
export function  orderDetailUpdate(data) {
  return request.post('recovery/order/show/update',data)
}

/**
 * 回收价格一键同步
 * */
export function  batchPrice() {
  return request.post('recovery/category/batch/price')
}

/**
 *
 * 出库
 * */

export function productOutbound(data) {
  return request.post('recovery/warehous/product/outbound',data)
}

/**
 * 订单详情
 */
export function recoveryOrderDetailApi(id) {
  return request.get(`recovery/order/detail/${id}`)
}


/**
 * @description 编辑每日库存
 * @param id number
 * @param data Object
 * */
export function stockSetDateUpdate(id,data) {
  return request.post(`recovery/stock/set/date/update/${id}`,data)
}

/**
 *
 * 获取每日库存表格
 * */
export function  stockCardDate(data) {
  return request.get('recovery/stock/export',data)
}

/**
 * @description 一键设置入库
 * @param id string
 * @param data object
 * */
export function dateQuicklyUpdate(id,data) {
  return request.post(`recovery/stock/set/date/quickly/update/${id}`,data)
}

/**
 * 甄豆提现列表
 * */
export function integralExtractList(data) {
  return request.get('user/integral/extract/list',data)
}

/**
 * 库存记录
 * */
export function warehousList(data) {
  return request.get('recovery/warehous/list',data)
}

/**
 * 编辑状态
 */
export function recoveryOrderUpdateApi(id) {
  return request.get(`recovery/order/update/form/${id}`)
}

/**
 * 每日库存
 * */
export function stockDateList(data) {
  return request.get('recovery/stock/date/list',data)
}

/**
 * 添加库存
 * */
export function stockAdd(data) {
  return request.post('recovery/stock/add',data)
}

/**
 * 修改甄豆
 * */
export function integralUpdate(data) {
  return request.post('recovery/category/sku/integral/update',data)
}

/**
 * @description  删除
 */
export function recoveryOrderDeleteApi(id) {
  return request.delete(`recovery/order/delete/${id}`)
}
/**
 * @description  处理异常订单
 */
export function recoveryOrderHandleWornApi(id) {
  return request.post(`recovery/order/cancel/worn/${id}`)
}
/**
 * @description  取消寄件
 */
export function recoveryOrderCancelExpressApi(id) {
  return request.post(`recovery/order/cancel/express/${id}`)
}
/**
 * @description  回收记录
 */
export function recoveryStockListApi(data) {
  return request.get(`recovery/stock/list`, data)
}

/**
 * @description 结算金额
 * */
export function outStockOrderSettlement(id,data) {
  return request.post(`recovery/outStockOrder/settlement/${id}`,data)
}

/**
 * @description 刪除訂單
 * */
export function outStockOrderDelete(id) {
 return request.delete(`recovery/outStockOrder/delete/${id}`)
}

/**
 *出库统计
 * */
export function outStockOrdercardList() {
    return request.get('recovery/outStockOrder/cardList')
}

/**
 * @description 完成订单
 * */
export function outStockOrderEnd(id,data) {
  return request.post(`recovery/outStockOrder/end/${id}`,data)
}

/**
 * 结算出库订单
 * */

export function outStockOrderUpdate(id,data) {
  return request.post(`recovery/outStockOrder/update/${id}`,data)
}

/**
 * @description 出库订单详情
 * */

export function outStockOrderDetail(id) {
  return request.get(`recovery/outStockOrder/detail/${id}`)
}


/**
 * @description 出库列表
 * */
export function outStockOrderLst(data) {
  return request.get('recovery/outStockOrder/lst',data)
}

/**
 * @description 创建出库订单
 * */
export function outStockOrderCreate(data) {
  return request.post('recovery/outStockOrder/create',data)
}

/**
 * @description 每日库存统计
 * */
export function tockCardDate(data) {
  return request.get('recovery/stock/card/date',data)
}

/**
 * @description 添加异常
 * */
export function stockSetWorn(id,data) {
  return request.post(`recovery/stock/set/worn/${id}`,data)
}

/**
 * @description  回收记录统计
 */
export function recoveryStockCardListApi(data) {
  return request.get(`recovery/stock/card`, data)
}

/**
 * @description 异常原因列表
 * */
export function wornLst() {
  return request.get('recovery/worn/lst')
}

/**
 * @description 客户列表
 * **/
export function customLst(data) {
  return request.get('recovery/custom/lst',data)
}

/**
 * @description 编辑库存
 * */
export function stockSetUpdate(id,data) {
  return request.post(`/recovery/stock/set/update/${id}`,data)
}

/**
 * @description 库存明细
 * */
export function stockDetailsLst(id,data) {
  return request.get(`recovery/stock/details/lst/${id}`,data)
}

/**
 * @description 删除客户
 * */
export function customDelete(id) {
  return request.delete(`recovery/custom/delete/${id}`)
}

/**
 *
 * @description 添加 修改客户
 * */
export function customCreate(id,data) {
  if(id){
    return request.post(`recovery/custom/update/${id}`,data)
  }else{
    return request.post(`recovery/custom/create`,data)
  }
}

/**
 * @description 原因删除
 * */
export function wornDelete(id) {
 return request.delete(`recovery/worn/delete/${id}`)
}

/**
 * @description 原因添加
 * */
export function wornCreate(data) {
  return request.post('recovery/worn/create',data)
}

/**
 * @description  回收记录统计
 */
export function recoveryOrderCardListApi(data) {
  return request.get(`recovery/order/card`, data)
}
/**
 * @description  回收记录统计
 */
export function recoveryOrderUpdateSublimitApi(id,data) {
  return request.post(`recovery/order/update/${id}`, data)
}

/**
 * @description  回收记录统计
 */
export function recoveryOrderBatchSettApi(data) {
  return request.post(`recovery/order/batch/sett`, data)
}

/**
 * @description  异常处理
 */
export function recoveryOrderWoreHandleSublimitApi(id,data) {
  return request.post(`recovery/order/wore/handle/${id}`, data)
}

/**
 * @description  退回列表
 */
export function recoveryOrderReturnApi(id) {
  return request.post(`recovery/order/return/list/${id}`)
}
/**
 * @description  退回处理
 */
export function recoveryOrderReturnHandleSublimitApi(id,data) {
  return request.post(`recovery/order/return/handle/${id}`,data)
}

/**
 * @description  处理异常订单
 */
export function recoveryOrderHandleReturnApi(id) {
  return request.post(`recovery/order/cancel/Return/${id}`)
}

/**
 * @description  更新库存
 */
export function recoveryOrderRenewWarehousExpressApi(data) {
  return request.post(`recovery/warehous/renew`,data)
}

/**
 * 手动添加库存记录
 * */
export function addWarehousList(data) {
  return request.get('recovery/warehous/add/list',data)
}
/**
 * @description  设置库存
 */
export function setRecoveryStockFormApi(id) {
  return request.get(`recovery/stock/set/form/${id}`)
}

/**
 * @description  库存
 */
export function RecoveryStockLadderListApi(data) {
  return request.get(`recovery/stock/ladder/list`, data)
}

/**
 * @description  结算记录
 */
export function recoveryOrderSettListApi(data) {
  return request.get(`recovery/order/sett/list`, data)
}

/**
 * @description  结算统计
 */
export function recoveryOrderSettChartListApi() {
  return request.get(`recovery/order/sett/chart/list`)
}

/**
 * @description  结算统计
 */
export function recoveryOrderSettCardListApi(data) {
  return request.get(`recovery/order/sett/card/list`, data)
}

/**
 * @description  结算
 */
export function recoveryOrderSettHandleApi(id) {
  return request.get(`recovery/order/sett/handle`, id)
}
/**
 * @description  删除
 */
export function recoveryOrderSettDeleteApi(id) {
  return request.delete(`recovery/order/sett/del/${id}`)
}


